import React, { useState, Fragment, useRef, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { useNavigate } from "react-router-dom"
import ReCAPTCHA from 'react-google-recaptcha'
import logo from '../../assets/img/odu-yatay.png'
import doku from '../../assets/img/bd-doku2.png'

import Toast from '../../component/Ui/Toast'
import { BsTrash } from "react-icons/bs"


import aktifDonemAPI from '../../services/aktifDonem';
import formPost from '../../services/formPost'
import uploadFiles from '../../services/uploadFiles'

import { BsArrowRightCircle, BsFillPersonPlusFill } from "react-icons/bs";


const BasvuruFormu = () => {


    const [donemKontrol, setDonemKontrol] = useState(false)
    const [aktifDonem, setAktifDonem] = useState({})


    // google reCaptcha
    const recaptchaRef = React.createRef();
    const [recaptchaVerified, setRecaptchaVerified] = useState(false);

    const onChangeRecaptcha = (value) => {
        if (value) {
            setRecaptchaVerified(true);
        } else {
            setRecaptchaVerified(false);
        }
    };

    const navigate = useNavigate()

    const [onay, setOnay] = useState(false)

    const [toast, setToast] = useState({
        showToast: false,
        message: "",
        type: "",
        title: ""
    })

    const [basvurumerkezi, setBasvurumerkezi] = useState(null)
    const [arastirmaBasligiTR, setArastirmaBasligiTR] = useState(null)
    const [arastirmaBasligiEN, setArastirmaBasligiEN] = useState(null)


    const [arastirmaciAdiSoyadi, setArastirmaciAdiSoyadi] = useState(null)
    const [arastimarciUnvani, setArastimarciUnvani] = useState(null)
    const [arastimaciFYE, setArastimaciFYE] = useState(null)
    const [arastimaciBolumAnabilimDali, setArastimaciBolumAnabilimDali] = useState(null)
    const [telefon, setTelefon] = useState(null)
    const [ePosta, setEPosta] = useState(null)
    const [adres, setAdres] = useState(null)



    const [yardimciArastirmaci, setYardimciArastirmaci] = useState([])
    const handleYardimciArastirmaci = () => {
        setYardimciArastirmaci([...yardimciArastirmaci,
        {
            yrdArastirmaciAdiSoyadi: "",
            yrdArastimarciUnvani: "",
            yrdArastimaciFYE: "",
            yrdArastimaciBolumAnabilimDali: "",
            yrdTelefon: "",
            yrdEPosta: "",
            yrdAdres: "",
        }
        ])
    }


    const handleYardimciArastirmaciDelete = (index) => {
        let values = [...yardimciArastirmaci]
        values.splice(index, 1)
        setYardimciArastirmaci(values)
    }

    const handleYardimciArastirmaciUpdate = (index, event) => {
        let values = [...yardimciArastirmaci]
        values[index][event.target.name] = event.target.value
        setYardimciArastirmaci(values)
    }


    const [veriToplamaPlatformu, setVeriToplamaPlatformu] = useState([])
    const handleVeriToplamaPlatformu = () => {
        setVeriToplamaPlatformu([...veriToplamaPlatformu,
        {
            name: ""
        }
        ])
    }

    const handleVeriToplamaPlatformuDelete = (index, e) => {
        let values = [...veriToplamaPlatformu]
        values.splice(index, 1)
        setVeriToplamaPlatformu(values)


    }

    const handleVeriToplamaPlatformuUpdate = (index, event) => {
        let values = [...veriToplamaPlatformu]
        values[index][event.target.name] = event.target.value
        setVeriToplamaPlatformu(values)
    }


    const [calismaTuru, setCalismaTuru] = useState(null)
    const [calismaTuruSelected, setCalismaTuruSelected] = useState(null)
    const handleCalismaTuru = (calismaTuru) => {

        if (calismaTuru === "Diğer") {
            setCalismaTuru(true)
        } else {
            setCalismaTuru(false)
        }
    }

    const [calismaDili, setCalismaDili] = useState(null)
    const handleCalismaDili = (calismaDili) => {
        // calismaDili = false ise dil Türkçedir, true ise dil İngilizcedir
        if (calismaDili === "İngilizce") {
            setCalismaDili("İngilizce")
        } else if (calismaDili === "Türkçe") {
            setCalismaDili("Türkçe")
        } else {
            setCalismaDili(null)
        }
    }



    const [koordinatorAdiSoyadi, setKoordinatorAdiSoyadi] = useState(null)
    const [koordinatorUnvani, setKoordinatorUnvani] = useState(null)
    const [koordinatorFYE, setKoordinatorFYE] = useState(null)
    const [koordinatorBolumAnabilimDali, setKoordinatorBolumAnabilimDali] = useState(null)
    const [koordinatorTelefon, setKoordinatorTelefon] = useState(null)
    const [kooridnatorEposta, setKooridnatorEposta] = useState(null)
    const [kooridnatorAdres, setKooridnatorAdres] = useState(null)



    const [arastirmaAmaci, setArastirmaAmaci] = useState(null)
    const [arastirmaYontemi, setArastirmaYontemi] = useState(null)
    const [calismaGurubu, setCalismaGurubu] = useState(null)
    const [calismaOlcutu, setCalismaOlcutu] = useState(null)
    const [olcmeAraci, setOlcmeAraci] = useState(null)



    const [uygulamaIzinKurum, setUygulamaIzinKurum] = useState(null)
    const [calismaRiskleri, setCalismaRiskleri] = useState(null)
    const [uygulamaSonlandirmaKosullari, setUygulamaSonlandirmaKosullari] = useState(null)
    const [katilimSonrasiBilgilendirme, setKatilimSonrasiBilgilendirme] = useState(null)
    const [medyaSaklamaKosullari, setMedyaSaklamaKosullari] = useState(null)
    const [referanslar, setReferanslar] = useState(null)

    const [veriToplamaDonemleri, setVeriToplamaDonemleri] = useState({
        baslangicTarihi: '',
        bitisTarihi: '',
    });

    const handleBaslangicTarihiChange = (e) => {
        setVeriToplamaDonemleri({
            ...veriToplamaDonemleri,
            baslangicTarihi: e.target.value,
        });
    };

    const handleBitisTarihiChange = (e) => {
        setVeriToplamaDonemleri({
            ...veriToplamaDonemleri,
            bitisTarihi: e.target.value,
        });
    };

    //const [veriToplamaPlatformu, setVeriToplamaPlatformu] = useState([])


    const [basvuruDilekcesiFile, setBasvuruDilekcesiFile] = useState(null)
    const [ozgecmisFile, setOzgecmisFile] = useState(null)
    const [kurulKarariFile, setKurulKarariFile] = useState(null)
    const [veliOnamFormuFile, setVeliOnamFormuFile] = useState(null)
    const [gonulluOnamFormuFile, setGonulluOnamFormuFile] = useState(null)
    const [veriToplamaAraclariFile, setVeriToplamaAraclariFile] = useState(null)
    const [veriToplamaIzinYazisiFile, setVeriToplamaIzinYazisiFile] = useState(null)
    const [veriToplamaAraclariEkFile, setVeriToplamaAraclariEkFile] = useState(null)




    const veriToplamaAraciCheckbox = [
        'Anket',
        'Gözlem (Yazılı notlar içeren)',
        'Başarı/Erişi Testi',
        'Resim/Çizim',
        'Bilgisayar ortamında test/anket/ölçek',
        'Görüşme/Mülakat',
        'Doküman incelemesi',
        'Gözlem (Ses ve/veya görüntü kaydı içeren)',
        'Ölçek',
        'Odak Grup Görüşmesi'
    ];


    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [digerVeriToplamaAraci, setDigerVeriToplamaAraci] = useState(null);




    const handleCheckboxChange = (value) => {
        if (selectedCheckboxes.includes(value)) {
            setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== value));
        } else {
            setSelectedCheckboxes([...selectedCheckboxes, value]);
        }
    };




    const data =
    {
        basvurumerkezi: basvurumerkezi,
        arastirmaDili: calismaDili,
        arastirmaBasligiTR: arastirmaBasligiTR,
        arastirmaBasligiEN: arastirmaBasligiEN,
        calismaTuru: calismaTuruSelected,
        arastirmaciAdiSoyadi: arastirmaciAdiSoyadi,
        arastimarciUnvani: arastimarciUnvani,
        arastimaciFYE: arastimaciFYE,
        arastimaciBolumAnabilimDali: arastimaciBolumAnabilimDali,
        telefon: telefon,
        ePosta: ePosta,
        adres: adres,
        yardimciArastirmaci: [
            yardimciArastirmaci
        ],
        koordinatorAdiSoyadi: koordinatorAdiSoyadi,
        koordinatorUnvani: koordinatorUnvani,
        koordinatorFYE: koordinatorFYE,
        koordinatorBolumAnabilimDali: koordinatorBolumAnabilimDali,
        koordinatorTelefon: koordinatorTelefon,
        kooridnatorEposta: kooridnatorEposta,
        kooridnatorAdres: kooridnatorAdres,
        arastirmaAmaci: arastirmaAmaci,
        veriToplamaAraci: selectedCheckboxes,
        digerveriToplamaAraci: digerVeriToplamaAraci,
        veriToplamaDonemleri: [veriToplamaDonemleri],
        veriToplamaPlatformu: [veriToplamaPlatformu],
        arastirmaYontemi: arastirmaYontemi,
        calismaGurubu: calismaGurubu,
        calismaOlcutu: calismaOlcutu,
        olcmeAraci: olcmeAraci,
        uygulamaIzinKurum: uygulamaIzinKurum,
        calismaRiskleri: calismaRiskleri,
        uygulamaSonlandirmaKosullari: uygulamaSonlandirmaKosullari,
        katilimSonrasiBilgilendirme: katilimSonrasiBilgilendirme,
        medyaSaklamaKosullari: medyaSaklamaKosullari,
        referanslar: referanslar,
        tahutnameOnay: true,
        basvuruDurumAciklama: "",
        donemId: aktifDonem.donemId,
        isDelete: false,
    }


    const handleFormSubmit = () => {
        recaptchaRef.current.reset();
        setRecaptchaVerified(false)

        if (basvurumerkezi === null || basvurumerkezi === "Seçiniz") {
            document.getElementById('basvuruturu').focus()

            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Başvuru türünü seçiniz",
                    title: "Hata"
                })
            )
        }
        if (calismaDili === null || calismaDili === "Seçiniz") {
            document.getElementById('calismadili').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Çalışma dilini seçiniz",
                    title: "Hata"
                })
            )
        }
        if (calismaTuruSelected === null || calismaTuruSelected === "Seçiniz") {
            document.getElementById('calismaturu').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Çalışma türünü seçiniz",
                    title: "Hata"
                })
            )
        }
        if (arastirmaBasligiTR === null || arastirmaBasligiTR === "") {

            document.getElementById('baslikTR').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Çalışmanızın Türkçe Başlığını Giriniz",
                    title: "Hata"
                })
            )
        }
        if ((arastirmaBasligiEN === null || arastirmaBasligiEN === "") && calismaDili === 'İngilizce') {
            document.getElementById('baslikEN').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Çalışmanızın İngilizce Başlığını Giriniz",
                    title: "Hata"
                })
            )
        }
        if (arastimarciUnvani === null || arastimarciUnvani === "") {
            document.getElementById('sorumluarastirmaciUnvani').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı Unvanını Giriniz",
                    title: "Hata"
                })
            )
        }
        if (arastirmaciAdiSoyadi === null || arastirmaciAdiSoyadi === "") {
            document.getElementById('sorumluarastirmaciAdiSoyadi').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı Adını Soyadını Giriniz",
                    title: "Hata"
                })
            )
        }
        if (ePosta === null || ePosta === "") {
            document.getElementById('sorumluarastirmaciEposta').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı E-Posta Adresini Giriniz",
                    title: "Hata"
                })
            )
        }
        if (telefon === null || telefon === "") {
            document.getElementById('sorumluarastirmaciTelefon').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı Telefon Numarasını Giriniz",
                    title: "Hata"
                })
            )
        }

        if (arastimaciFYE === null || arastimaciFYE === "") {
            document.getElementById('sorumluarastirmaciFYE').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı Fakülte/Yük.Okul/Enstitü Giriniz",
                    title: "Hata"
                })
            )
        }
        if (arastimaciBolumAnabilimDali === null || arastimaciBolumAnabilimDali === "") {
            document.getElementById('sorumluarastirmaciBolumAnabilimDali').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı Bölüm/Anabilim Dalı Giriniz",
                    title: "Hata"
                })
            )
        }
        if (adres === null || adres === "") {
            document.getElementById('sorumluarastirmaciAdres').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmacı Adresini Giriniz",
                    title: "Hata"
                })
            )
        }

        if (arastirmaAmaci === null || arastirmaAmaci === "") {
            document.getElementById('arastirmaAmaci').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Sorumlu Araştırmanın Amacını Giriniz",
                    title: "Hata"
                })
            )
        }

        if (veriToplamaDonemleri.baslangicTarihi === "") {
            document.getElementById('baslangicTarihi').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Veri Toplama Dönem Başlangıç Tarihini Giriniz",
                    title: "Hata"
                })
            )
        }

        if (veriToplamaDonemleri.bitisTarihi === "") {
            document.getElementById('bitisTarihi').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen Veri Toplama Dönem Bitiş Tarihini Giriniz",
                    title: "Hata"
                })
            )
        }

        if (arastirmaYontemi === null || arastirmaYontemi === "") {
            document.getElementById('arastirmaYontemi').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Araştırmayı hangi yöntem ya da yöntemlerle gerçekleştireceğinizi belirtiniz",
                    title: "Hata"
                })
            )
        }
        if (calismaGurubu === null || calismaGurubu === "") {
            document.getElementById('calismaGurubu').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Çalışma grubunuzu tanımlayınız",
                    title: "Hata"
                })
            )
        }
        if (calismaOlcutu === null || calismaOlcutu === "") {
            document.getElementById('calismaOlcutu').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Çalışma grubu için dâhil olma ve varsa dışta kalma ölçütlerini yazınız",
                    title: "Hata"
                })
            )
        }

        if (olcmeAraci === null || olcmeAraci === "") {
            document.getElementById('olcmeAraci').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Kullanılacak ölçme aracı/araçlarının kapsamını açık bir şekilde yazınız",
                    title: "Hata"
                })
            )
        }
        if (uygulamaIzinKurum === null || uygulamaIzinKurum === "") {
            document.getElementById('uygulamaIzinKurum').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Uygulama için gerekli izinleri hangi kurumlardan aldınız/almayı planlıyorsunuz?",
                    title: "Boş Bırakmayınız"
                })
            )
        }
        if (calismaRiskleri === null || calismaRiskleri === "") {
            document.getElementById('calismaRiskleri').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Çalışmanın uygulama yapacağınız/veri toplayacağınız kişiler açısından olası riskleri nelerdir?",
                    title: "Boş Bırakmayınız"
                })
            )
        }
        if (uygulamaSonlandirmaKosullari === null || uygulamaSonlandirmaKosullari === "") {
            document.getElementById('uygulamaSonlandirmaKosullari').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Araştırmaya katılan bireylerin araştırmadan ayrılma ya da uygulamayı sonlandırma koşulları nelerdir?",
                    title: "Boş Bırakmayınız"
                })
            )
        }
        if (katilimSonrasiBilgilendirme === null || katilimSonrasiBilgilendirme === "") {
            document.getElementById('katilimSonrasiBilgilendirme').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Çalışmanın katılımcılara, herhangi bir şekilde yanlı/yanlış bilgi vermeyi, çalışmanın amacını kısmen/tamamen gizli tutmayı gerektiriyor mu?",
                    title: "Boş Bırakmayınız"
                })
            )
        }
        if (medyaSaklamaKosullari === null || medyaSaklamaKosullari === "") {
            document.getElementById('medyaSaklamaKosullari').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Araştırmada, eğer varsa, ses ve görüntü verilerinin toplanmasında kullanılacak yöntemler yürürlükteki mevzuata uygun mu?",
                    title: "Boş Bırakmayınız"
                })
            )
        }




        // Dosya Upload Kontrolü
        if (basvuruDilekcesiFile === null) {
            document.getElementById('basvurudilekcesi').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Başvuru dilekçenizi ekleyiniz",
                    title: "Hata"
                })
            )
        }
        if (veriToplamaAraclariFile === null) {
            document.getElementById('veriToplamaAraclariFile').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Veri Toplama Araçları Dosya Ekleyiniz",
                    title: "Hata"
                })
            )
        }
        if (basvurumerkezi === 'Kurum Dışı' && ozgecmisFile === null) {
            document.getElementById('ozgecmis').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Özgeçmiş ekleyiniz",
                    title: "Hata"
                })
            )
        }
        if ((calismaTuruSelected === 'Yüksek Lisans Tezi' || calismaTuruSelected === 'Doktora Tezi') && kurulKarariFile === null) {
            document.getElementById('kurulkarari').focus()
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Enstitü/Anabilim Dalı Kurul Kararı Ekleyiniz",
                    title: "Hata"
                })
            )
        }


        if (!onay) {
            document.getElementById('taahutname').focus()
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            return (
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Lütfen taahütnameyi kabul ediniz",
                    title: "Hata"
                })
            )
        }

        formSubmit()

    }


    const [openModal, setOpenModal] = useState(false)
    const [resultData, setResultData] = useState()
    const cancelButtonRef = useRef(null)

    const formSubmit = async () => {
        const result = await formPost(data)
        if (result) {
            const filesData = new FormData()
            filesData.append('basvuruDilekcesiFile', basvuruDilekcesiFile)
            filesData.append('ozgecmisFile', ozgecmisFile)
            filesData.append('kurulKarariFile', kurulKarariFile)
            filesData.append('veliOnamFormuFile', veliOnamFormuFile)
            filesData.append('gonulluOnamFormuFile', gonulluOnamFormuFile)
            filesData.append('veriToplamaAraclariFile', veriToplamaAraclariFile)
            filesData.append('veriToplamaIzinYazisiFile', veriToplamaIzinYazisiFile)
            filesData.append('veriToplamaAraclariEkFile', veriToplamaAraclariEkFile)

            const uploadFilesResult = await uploadFiles(filesData, result.basvuruNo, result.token)
            if (uploadFilesResult) {
                setResultData(uploadFilesResult)
                setOpenModal(true)
            }

        } else {
            setToast({
                showToast: true,
                type: 'Error',
                message: "Bir hata oluştu lütfen daha sonra tekrar deneyiniz.",
                title: "Kayıt başarısız!"
            })
        }
    }


    const handleSizeControl = (file) => {

        if (file) {
            if (file.size >= 5242880) {
                setToast({
                    showToast: true,
                    type: 'Error',
                    message: "Eklediğiniz dosya boyutu 5MB den fazla olamaz",
                    title: "Hata"
                })
                return false
            } else {
                return true
            }
        }
    }



    useEffect(() => {
        const fecthData = async () => {
            const result = await aktifDonemAPI()
            if (result === false) {
                setDonemKontrol(result)
                navigate("/")
            } else {
                setDonemKontrol(true)
                setAktifDonem(result)
            }

            data.donemId = result.donemId
        }
        fecthData()
        //eslint-disable-next-line
    }, []);

    return (
        <>
            {
                donemKontrol !== false ? (
                    <div className='relative flex justify-center items-center w-full min-h-screen pb-11' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                        <div className='mx-auto w-full max-w-5xl pt-11'>
                            <div>
                                <img src={logo} alt='Ordu Üniversitesi' className='mb-6 h-20 mx-auto' />
                            </div>
                            <div className='text-center font-semibold text-slate-500 text-lg'>
                                EĞİTİM ARAŞTIRMALARI ETİK KURUL BAŞVURU FORMU
                            </div>
                            <div className='border rounded-md mt-6 mb-6 mx-4 lg:mx-0 px-6 py-8 text-slate-500 space-y-3 text-sm'>
                                <div className=''>
                                    <div className='grid grid-cols-12 gap-4'>
                                        {/* BAŞVURU TÜRÜ */}
                                        <div className='col-span-12 md:col-span-4'>
                                            <label>Başvuru Türü</label>
                                            <select id='basvuruturu' onChange={(e) => {
                                                setBasvurumerkezi(e.target.value)
                                                if (e.target.value !== 'Kurum Dışı') { setOzgecmisFile([]) }
                                            }} className='w-full mb-3 border border-slate-300 text-sm h-8 px-3 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                <option value={null}>Seçiniz</option>
                                                <option value="Kurum İçi">Kurum İçi</option>
                                                <option value="Kurum Dışı">Kurum Dışı</option>
                                            </select>
                                        </div>
                                        {/* BAŞVURU DİLİ */}
                                        <div className='col-span-12 md:col-span-4'>
                                            <label>Çalışma Dili</label>
                                            <select id='calismadili' onChange={
                                                (e) => {
                                                    handleCalismaDili(e.target.value)
                                                }
                                            }
                                                className='w-full mb-3 border border-slate-300 text-sm h-8 px-3 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                <option value={null}>Seçiniz</option>
                                                <option value="Türkçe">Türkçe</option>
                                                <option value="İngilizce">İngilizce</option>
                                            </select>
                                        </div>
                                        {/* ÇALIŞMA TÜRÜ */}
                                        <div className='col-span-12 md:col-span-4'>
                                            <label>Çalışma Türü</label>
                                            <select id='calismaturu' onChange={
                                                (e) => {
                                                    handleCalismaTuru(e.target.value)
                                                    setCalismaTuruSelected(e.target.value)
                                                    if (e.target.value !== 'Yüksek Lisans Tezi' || e.target.value !== 'Doktora Tezi') { setKurulKarariFile([]) }
                                                }
                                            }
                                                className='w-full mb-3 border border-slate-300 text-sm h-8 px-3 py-1 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all'>
                                                <option value={null}>Seçiniz</option>
                                                <option value="Makale/Bildiri">Makale/Bildiri</option>
                                                <option value="Yüksek Lisans Tezi">Yüksek Lisans Tezi</option>
                                                <option value="Doktora Tezi">Doktora Tezi</option>
                                                <option value="ODU BAP">ODU BAP</option>
                                                <option value="Bitirme Projesi / Tezi">Bitirme Projesi / Tezi</option>
                                                <option value="Tübitak Projesi">Tübitak Projesi</option>
                                                <option value="Diğer">Diğer</option>
                                            </select>
                                            {
                                                calismaTuru ? (
                                                    <div>
                                                        <label>Diğer Çalışma Türü</label>
                                                        <input onChange={(e) => { setCalismaTuruSelected(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>
                                                ) : null
                                            }
                                        </div>
                                        {/* ARAŞTIRMA BAŞLIĞI */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>Araştırmanın Başlığı</h3>
                                        </div>
                                        <div className='col-span-12'>
                                            <label className=''>Türkçe</label>
                                            <input id='baslikTR' onChange={(e) => { setArastirmaBasligiTR(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />

                                            {
                                                calismaDili === 'İngilizce' ? (
                                                    <>
                                                        <label className=''>İngilizce</label>
                                                        <input id='baslikEN' onChange={(e) => { setArastirmaBasligiEN(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </>
                                                ) : null
                                            }

                                        </div>
                                        {/* SORUMLU ARAŞTIRMACI */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>Sorumlu Araştırmacı Bilgileri</h3>
                                        </div>
                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>Unvanı</label>
                                            <input id='sorumluarastirmaciUnvani' onChange={(e) => { setArastimarciUnvani(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>Adı Soyadı</label>
                                            <input id='sorumluarastirmaciAdiSoyadi' onChange={(e) => { setArastirmaciAdiSoyadi(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>E-Posta</label>
                                            <input id='sorumluarastirmaciEposta' onChange={(e) => { setEPosta(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>Telefon</label>
                                            <input id='sorumluarastirmaciTelefon' onChange={(e) => { setTelefon(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6'>
                                            <label>Fakülte / Yük. Okul / Enstitü </label>
                                            <input id='sorumluarastirmaciFYE' onChange={(e) => { setArastimaciFYE(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6'>
                                            <label>Bölüm / Anabilim Dalı </label>
                                            <input id='sorumluarastirmaciBolumAnabilimDali' onChange={(e) => { setArastimaciBolumAnabilimDali(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        <div className='col-span-12'>
                                            <label>Adres </label>
                                            <input id='sorumluarastirmaciAdres' onChange={(e) => { setAdres(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        <div className='col-span-12'>
                                            <div className='flex justify-between items-center'>
                                                <h3 className='mb-2 font-semibold text-slate-600'>Yardımcı Araştırmacı<p className='text-xs text-slate-400 font-normal'>Yardımcı araştırma varsa ekle butonuna tıklayarak ekleyebilirsiniz</p></h3>
                                                <button onClick={handleYardimciArastirmaci} className='inline-flex items-center gap-x-2 bg-blue-600 hover:bg-blue-800 px-2 py-1 rounded text-white text-xs transition-colors duration-150'><BsFillPersonPlusFill className='text-xl' />Ekle</button>
                                            </div>
                                        </div>


                                        {
                                            yardimciArastirmaci.map((yardimci, index) => (
                                                <div key={index} className='grid col-span-12 grid-cols-12 gap-4 w-full bg-slate-200 px-3 py-2 rounded-md'>
                                                    <div className='col-span-12 -mb-3 font-semibold'>
                                                        <div className='flex justify-between items-center'>
                                                            <label>{index + 1}. Yardımcı Araştırmacı</label>
                                                            <button className='bg-red-500 hover:bg-red-700 text-white  rounded-full  w-6 h-6 text-xs font-normal' onClick={() => { handleYardimciArastirmaciDelete(index) }}>Sil</button>
                                                        </div>
                                                    </div>
                                                    <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                                        <label>Unvanı</label>
                                                        <input name='yrdArastimarciUnvani' value={yardimci.yrdArastimarciUnvani} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>

                                                    <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                                        <label>Adı Soyadı</label>
                                                        <input name='yrdArastirmaciAdiSoyadi' value={yardimci.yrdArastirmaciAdiSoyadi} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>

                                                    <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                                        <label>E-Posta</label>
                                                        <input name='yrdEPosta' value={yardimci.yrdEPosta} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>
                                                    <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                                        <label>Telefon</label>
                                                        <input name='yrdTelefon' value={yardimci.yrdTelefon} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>

                                                    <div className='col-span-12 md:col-span-6'>
                                                        <label>Fakülte / Yük. Okul / Enstitü </label>
                                                        <input name='yrdArastimaciFYE' value={yardimci.yrdArastimaciFYE} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>

                                                    <div className='col-span-12 md:col-span-6'>
                                                        <label>Bölüm / Anabilim Dalı </label>
                                                        <input name='yrdArastimaciBolumAnabilimDali' value={yardimci.yrdArastimaciBolumAnabilimDali} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>
                                                    <div className='col-span-12'>
                                                        <label>Adres </label>
                                                        <input name='yrdAdres' value={yardimci.yrdAdres} onChange={(e) => { handleYardimciArastirmaciUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                    </div>
                                                </div>
                                            ))
                                        }


                                        {/* KOORDİNATÖR */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>Koordinatör<p className='text-xs text-slate-400 font-normal'>Çok merkezli araştırmalar için doldurunuz</p></h3>
                                        </div>
                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>Unvanı</label>
                                            <input onChange={(e) => { setKoordinatorUnvani(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>Adı Soyadı</label>
                                            <input onChange={(e) => { setKoordinatorAdiSoyadi(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>E-Posta</label>
                                            <input onChange={(e) => { setKooridnatorEposta(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        <div className='col-span-12 md:col-span-6 lg:col-span-3'>
                                            <label>Telefon</label>
                                            <input onChange={(e) => { setKoordinatorTelefon(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6'>
                                            <label>Fakülte / Yük. Okul / Enstitü </label>
                                            <input onChange={(e) => { setKoordinatorFYE(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6'>
                                            <label>Bölüm / Anabilim Dalı </label>
                                            <input onChange={(e) => { setKoordinatorBolumAnabilimDali(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        <div className='col-span-12'>
                                            <label>Adres </label>
                                            <input onChange={(e) => { setKooridnatorAdres(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>





                                        {/* 1. SORU */}
                                        <div className='col-span-12 bg-slate-200 rounded  px-4 py-1'>
                                            <strong>Açıklama</strong>
                                            <p>
                                                Lütfen her bir soruyu, sorunun altında bırakılan boşluğa açık bir şekilde cevaplandırınız. Aşağıda yer alan sorulardan araştırma problemi/türü açısından cevaplandırılamaz soruları boş bırakınız.
                                            </p>
                                        </div>
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>1. Araştırmanın amacı ve varsa alt problemlerini açık bir şekilde yazınız</h3>
                                            <textarea id='arastirmaAmaci' onChange={(e) => { setArastirmaAmaci(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* 2. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>2. Veri Toplama Aracının/Araçlarının Türü <p className='text-xs text-slate-400 font-normal'>Birden fazla seçenek işaretlenebilir.</p></h3>
                                        </div>

                                        {
                                            veriToplamaAraciCheckbox.map((option, key) => (
                                                <div key={key} className='col-span-12 md:col-span-4'>
                                                    <div className="relative flex items-start">
                                                        <div className="flex h-6 items-center">
                                                            <input
                                                                id={key}
                                                                type="checkbox"
                                                                value={option}
                                                                checked={selectedCheckboxes.includes(option)}
                                                                onChange={() => handleCheckboxChange(option)}
                                                                className="h-4 w-4 rounded border-slate-100 text-indigo-600 focus:ring-indigo-600"
                                                            />
                                                        </div>
                                                        <div className="ml-3 text-sm leading-6">
                                                            <label htmlFor={key}>
                                                                {option}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }

                                        <div className='col-span-8'>
                                            <label>Diğer</label>
                                            <input onChange={(e) => { setDigerVeriToplamaAraci(e.target.value) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>


                                        {/* 3. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>3. Veri Toplanması Planlanan Dönem(ler)</h3>
                                        </div>
                                        <div className='col-span-12 md:col-span-6'>
                                            <label>Başlangıç</label>
                                            <input id='baslangicTarihi' value={veriToplamaDonemleri.baslangicTarihi}
                                                onChange={handleBaslangicTarihiChange} type='date' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        <div className='col-span-12 md:col-span-6'>
                                            <label>Bitiş</label>
                                            <input id="bitisTarihi" value={veriToplamaDonemleri.bitisTarihi}
                                                onChange={handleBitisTarihiChange} type='date' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>


                                        {/* 4. SORU */}

                                        <div className='col-span-12'>
                                            <div className='flex justify-between items-center'>
                                                <h3 className='font-semibold text-slate-600'>4. Veri Toplanması Planlanan Yerler/Mekânlar, Çevrimiçi Platformlar, Kurum ve Kuruluşlar</h3>
                                                <button onClick={handleVeriToplamaPlatformu} className='inline-flex items-center gap-x-2 bg-blue-600 hover:bg-blue-800 px-2 py-1 rounded text-white text-xs transition-colors duration-150'><BsFillPersonPlusFill className='text-xl' />Ekle</button>
                                            </div>
                                        </div>
                                        {
                                            veriToplamaPlatformu.map((item, index) => (
                                                <div key={index} className='col-span-12'>
                                                    <div className='flex justify-between items-center mb-2'>
                                                        <label>Yerler/Mekânlar, Çevrimiçi Platformlar, Kurum ve Kuruluş Adı</label>
                                                        <button className='bg-red-500 hover:bg-red-700 text-white  rounded-full  w-6 h-6 text-xs font-normal' onClick={(e) => { handleVeriToplamaPlatformuDelete(index, e) }}>Sil</button>
                                                    </div>
                                                    <input name='name' value={item.name} onChange={(e) => { handleVeriToplamaPlatformuUpdate(index, e) }} type='text' placeholder='' className='w-full mb-3 border border-slate-300 text-sm h-8 leading-5 px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                                </div>
                                            ))
                                        }



                                        {/* 5. SORU */}
                                        <div className='col-span-12 mt-4'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>5. Araştırmayı hangi yöntem ya da yöntemlerle gerçekleştireceğinizi aşamalı ve detaylı bir şekilde yazınız.</h3>
                                            <textarea id="arastirmaYontemi" onChange={(e) => { setArastirmaYontemi(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* 6. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>6. Çalışma grubunuzu tanımlayınız (Yaş, örneklem büyüklüğü, vb.).</h3>
                                            <textarea id='calismaGurubu' onChange={(e) => { setCalismaGurubu(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        {/* 7. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>7. Seçeceğiniz çalışma grubu için dâhil olma ve varsa dışta kalma ölçütlerini detaylı bir şekilde yazınız. <p className='text-xs text-slate-400 font-normal'>Çocukların (18 yaş altı) oluşturacağı çalışma gruplarında, katılımcıları çalışmaya davet etmeye yönelik yapacağınız açıklamayı yazınız. </p></h3>
                                            <textarea id='calismaOlcutu' onChange={(e) => { setCalismaOlcutu(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* 8. SORU */}

                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>8. Kullanılacak ölçme aracı/araçlarının kapsamını açık bir şekilde yazınız ve bu araçlara yönelik maddeleri başvuru formuna ekleyiniz </h3>
                                            <div className='col-span-12 bg-slate-200 rounded  px-4 py-1 mb-2'>
                                                <p>Hem araştırmacı/araştırmacılar tarafından geliştirilen hem de farklı araştırmacıların geliştirdiği veri toplama araçlarına yönelik maddeler ekte paylaşılmalı, bu başlık altında isimlerine yer verilmeli ve daha önce geliştirilmiş veri toplama araçlarının referansları bu başlık altında yer almalıdır. Veri toplama araçları açık erişime sahip ise referansları ile birlikte açık erişimde oldukları açıkça belirtilmeli(URL verilmeli), açık erişime sahip değilse veri toplama aracı kullanım izni ekte sunulmalıdır.</p>
                                            </div>
                                            <textarea id='olcmeAraci' onChange={(e) => { setOlcmeAraci(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* 9. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>9. Uygulama için gerekli izinleri hangi kurumlardan aldınız/almayı planlıyorsunuz?</h3>
                                            <textarea id='uygulamaIzinKurum' onChange={(e) => { setUygulamaIzinKurum(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        {/* 10. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>10. Bu çalışmanın uygulama yapacağınız/veri toplayacağınız kişiler açısından olası riskleri nelerdir? Bu olası risklere karşı ne tür önlemler almayı planlıyorsunuz?</h3>
                                            <textarea id='calismaRiskleri' onChange={(e) => { setCalismaRiskleri(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>
                                        {/* 11. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>11. Araştırmaya katılan bireylerin araştırmadan ayrılma ya da uygulamayı sonlandırma koşulları nelerdir?</h3>
                                            <textarea id='uygulamaSonlandirmaKosullari' onChange={(e) => { setUygulamaSonlandirmaKosullari(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* 12. SORU */}

                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>12. Çalışmanın katılımcılara, herhangi bir şekilde yanlı/yanlış bilgi vermeyi, çalışmanın amacını kısmen/tamamen gizli tutmayı gerektiriyor mu? </h3>
                                            <div className='col-span-12 bg-slate-200 rounded  px-4 py-1 mb-2'>
                                                <p>Eğer cevabınız <strong>‘Kısmen gizleniyor, aldatma yok’</strong> veya <strong>‘Gizleniyor, aldatma var’</strong> ise, gerekçesini belirterek Katılım Sonrası Bilgilendirme Formunuzu başvurunuza ekleyiniz.</p>
                                            </div>
                                            <textarea id='katilimSonrasiBilgilendirme' onChange={(e) => { setKatilimSonrasiBilgilendirme(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>


                                        {/* 13. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>13. Araştırmada, eğer varsa, ses ve görüntü verilerinin toplanmasında kullanılacak yöntemler yürürlükteki mevzuata uygun mu? <p className='text-xs text-slate-400 font-normal'>Bu verilerin hangi amaçla toplanacağı, nasıl saklanacağı ve araştırma bitiminde nasıl imha edileceği açıklanmalıdır.</p></h3>
                                            <textarea id='medyaSaklamaKosullari' onChange={(e) => { setMedyaSaklamaKosullari(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* 14. SORU */}
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>14. Referanslar (Varsa)</h3>
                                            <textarea onChange={(e) => { setReferanslar(e.target.value) }} rows='2' placeholder='' className='w-full mb-3 border border-slate-300 text-sm px-3 py-2 rounded outline-dashed outline-offset-2 outline-1 outline-transparent focus:outline-slate-300 transition-all' />
                                        </div>

                                        {/* DOSYALAR */}
                                        <div className='col-span-12 bg-slate-200 rounded  px-4 py-1'>
                                            <strong>Açıklama</strong>
                                            <ul>
                                                <li><strong>"Enstitü/Anabilim Dalı Kurul Kararı"</strong> Yüksek lisans ve doktora tezleri için zorunludur.</li>
                                                <li><strong>"Özgeçmiş"</strong> Kurum dışı başvurular için zorunludur.</li>
                                                <li><strong>"Veri toplama aracı açık erişime sahip değilse izin yazısı"</strong> Ölçek, Anket vb..</li>
                                            </ul>
                                        </div>
                                        <div className='col-span-12'>
                                            <h3 className='mb-2 font-semibold text-slate-600'>DOSYALAR</h3>
                                        </div>
                                        <div className='col-span-12 md:col-span-6'>
                                            <div>
                                                <label htmlFor="image" className="block text-sm text-gray-500 ">Başvuru Dilekçesi <span className='text-red-600'>(*)</span></label>
                                                <input id='basvurudilekcesi' onChange={(e) => { setBasvuruDilekcesiFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                            </div>
                                        </div>
                                        <div className='col-span-12 md:col-span-6'>
                                            <div>
                                                <label htmlFor="image" className="block text-sm text-gray-500 ">Veli Onam Formu</label>
                                                <input onChange={(e) => { setVeliOnamFormuFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                            </div>
                                        </div>
                                        <div className='col-span-12 md:col-span-6'>
                                            <div>
                                                <label htmlFor="image" className="block text-sm text-gray-500 ">Gönüllü Onam Formu</label>
                                                <input onChange={(e) => { setGonulluOnamFormuFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                            </div>
                                        </div>
                                        {
                                            calismaTuruSelected === 'Yüksek Lisans Tezi' || calismaTuruSelected === 'Doktora Tezi' ? (
                                                <div className='col-span-12 md:col-span-6'>
                                                    <div>
                                                        <label htmlFor="image" className="block text-sm text-gray-500 ">Enstitü/Anabilim Dalı Kurul Kararı<span className='text-red-600'>(*)</span></label>
                                                        <input id='kurulkarari' onChange={(e) => { setKurulKarariFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        {
                                            basvurumerkezi === 'Kurum Dışı' ? (
                                                <div className='col-span-12 md:col-span-6'>
                                                    <div>
                                                        <label className="block text-sm text-gray-500 ">Özgeçmiş<span className='text-red-600'>(*)</span></label>
                                                        <input id='ozgecmis' onChange={(e) => { setOzgecmisFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                        <div className='col-span-12 md:col-span-6'>
                                            <div>
                                                <label className="block text-sm text-gray-500 ">Veri Toplama Araçları<span className='text-red-600'>(*)</span></label>
                                                <input id='veriToplamaAraclariFile' onChange={(e) => { setVeriToplamaAraclariFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                            </div>
                                        </div>
                                        <div className='col-span-12 md:col-span-6'>
                                            <div>
                                                <label className="block text-sm text-gray-500 ">Veri toplama aracı açık erişime sahip değilse izin yazısı</label>
                                                <input onChange={(e) => { setVeriToplamaIzinYazisiFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                            </div>
                                        </div>
                                        <div className='col-span-12 md:col-span-6'>
                                            <div>
                                                <label className="block text-sm text-gray-500 ">Veri toplama aracı açık erişime sahipse linki (8. madde altında verilmelidir) ve eklere veri toplama aracının geçtiği yayın eklenmelidir.</label>
                                                <input onChange={(e) => { setVeriToplamaAraclariEkFile(handleSizeControl(e.target.files[0]) ? e.target.files[0] : null) }} type="file" className="block w-full px-3 py-2 mt-2 text-sm text-gray-600 bg-white border border-gray-200 rounded-lg file:bg-gray-200 file:text-gray-700 file:text-sm file:px-4 file:py-1 file:border-none file:rounded-full    placeholder-gray-400/70  focus:border-blue-400 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40   " />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className='text-justify text-sm text-slate-500 mb-8 border border-slate-400 p-4 rounded-md'>
                                <p>
                                    <strong>"{data.arastirmaBasligiTR}"</strong> başlıklı çalışma boyunca başvuru formunda taahhüt ettiğimiz şekilde araştırmamızı yürüteceğimizi, sunulan projede gerek araştırma ekibi gerekse araştırma protokolünde herhangi bir değişiklik yapıldığında, değişiklik gerçekleştirilmeden önce durumu kurulunuza bildireceğimizi, bu projenin kurulunuza sunduğumuz hâli ile daha önce başka bir Etik Kurul’a sunulmadığını, başvuru dosyasında yer alan bilgilerin doğru olduğunu ve araştırmanın hiçbir sürecinde herhangi bir etik ihlal yapmayacağımızı, bu yönde yürürlükte bulunan tüm mevzuat hükümlerine uyacağımızı ve Etik Kurul onayı alındıktan sonra araştırmadan vazgeçilmesi durumunda Etik Kurul’u yazılı olarak bilgilendireceğimizi aşağıda imzası bulunan araştırmacılar olarak taahhüt ederiz.
                                </p>
                                <div className="relative flex items-start mt-6">
                                    <div className="flex h-6 items-center">
                                        <input
                                            id='taahutname'
                                            type="checkbox"
                                            value="Taahütnameyi okudum, kabul ediyorum"
                                            className="h-4 w-4 rounded border-slate-100"
                                            onChange={() => { setOnay(!onay) }}
                                        />
                                    </div>
                                    <div className="ml-3 text-sm leading-6 ">
                                        <label htmlFor='taahutname'>
                                            Taahütnameyi okudum, kabul ediyorum
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className='text-center'>
                                <div className='flex justify-center mb-3'>
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                        onChange={(value) => onChangeRecaptcha(value)} />
                                </div>
                                <button disabled={!recaptchaVerified}
                                    onClick={handleFormSubmit}
                                    className='bg-slate-500 disabled:bg-slate-400 disabled:hover:bg-slate-400 border-slate-400 border hover:bg-slate-400 inline-flex justify-between items-center gap-x-4 text-white text-sm px-4 py-2 rounded-md outline-transparent outline-offset-2 outline-dashed focus:outline-slate-400 focus:outline-1'
                                >
                                    BAŞVURUYU TAMAMLA
                                    <span className='text-lg'>
                                        <BsArrowRightCircle />
                                    </span>
                                </button>
                            </div>


                        </div>

                    </div>
                ) : (
                    <div className='relative flex justify-center items-center w-full min-h-screen' style={{ backgroundImage: `url(${doku})`, backgroundRepeat: 'repeat-x' }}>
                        <div className='mx-auto w-full max-w-4xl pt-11'>
                            <div role="status" className=" animate-pulse">
                                <div className="h-2.5 bg-gray-200 rounded-full w-48 mb-4"></div>
                                <div className="h-2 bg-gray-200 rounded-full  max-w-[360px] mb-2.5"></div>
                                <div className="h-2 bg-gray-200 rounded-full  mb-2.5"></div>
                                <div className="h-2 bg-gray-200 rounded-full  max-w-[330px] mb-2.5"></div>
                                <div className="h-2 bg-gray-200 rounded-full  max-w-[300px] mb-2.5"></div>
                                <div className="h-2 bg-gray-200 rounded-full  max-w-[360px]"></div>
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                )
            }

            <Transition.Root show={openModal} as={Fragment}>
                <Dialog as="div" className="relative z-50" initialFocus={cancelButtonRef} onClose={() => setOpenModal(true)}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-50 overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div>
                                        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100">
                                            <BsTrash className="h-6 w-6 text-emerald-500" aria-hidden="true" />
                                        </div>
                                        <div className="mt-3 text-center sm:mt-5">
                                            <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-slate-900">
                                                Kayıt işlemi gerçekleşmiştir.
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <p className="text-sm text-slate-500">
                                                    Başvurunuzun çıktısını almayı unutmayınız.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-6">
                                        <button
                                            type="button"
                                            className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 sm:col-start-2"
                                            onClick={() => navigate("/form-print/" + resultData.basvuruNo, { state: resultData })}
                                        >
                                            Tamam
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>

            {
                toast.showToast ? (
                    <Toast setToast={setToast} message={toast.message} type={toast.type} title={toast.title} />
                ) : ""
            }
        </>
    );
}

export default BasvuruFormu;
